import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSearch, FaShip } from 'react-icons/fa';
import { CRUISE_PHONE_TEL } from '../../constants/contact';
import { CRUISE_REGIONS } from '../../data/cruiseData';

export default function CruiseSearchWidget({ compact = false }) {
  const navigate = useNavigate();
  const [cruise, setCruise] = useState({
    port: '',
    region: 'Caribbean',
    depart: '',
    adults: '2',
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const params = new URLSearchParams({
      port: cruise.port.trim() || 'Miami',
      destination: cruise.region,
      guests: cruise.adults,
    });
    if (cruise.depart) params.set('depart', cruise.depart);
    navigate(`/cruises/search?${params.toString()}`);
  };

  const rootClass = ['mcr-search-widget', compact ? 'mcr-search-widget--compact' : ''].filter(Boolean).join(' ');

  return (
    <div className={rootClass}>
      {!compact && (
        <div className="mcr-search-widget__tabs mcr-search-widget__tabs--single" role="tablist">
          <button type="button" role="tab" aria-selected className="active">
            <FaShip aria-hidden /> Cruises
          </button>
        </div>
      )}
      <form className="mcr-search-widget__form" onSubmit={handleSubmit}>
        <div className="mcr-search-row">
          <div className="mcr-search-grid mcr-search-grid--cruises">
            <label className="mcr-search-cell">
              <span className="mcr-search-cell__label">Departure port</span>
              <input
                type="text"
                value={cruise.port}
                onChange={(e) => setCruise({ ...cruise, port: e.target.value })}
                placeholder="Port or city"
                required
              />
            </label>
            <label className="mcr-search-cell">
              <span className="mcr-search-cell__label">Region</span>
              <select value={cruise.region} onChange={(e) => setCruise({ ...cruise, region: e.target.value })}>
                {CRUISE_REGIONS.map((r) => (
                  <option key={r} value={r}>
                    {r}
                  </option>
                ))}
              </select>
            </label>
            <label className="mcr-search-cell">
              <span className="mcr-search-cell__label">Depart</span>
              <input
                type="date"
                value={cruise.depart}
                onChange={(e) => setCruise({ ...cruise, depart: e.target.value })}
                required
              />
            </label>
            <label className="mcr-search-cell">
              <span className="mcr-search-cell__label">Guests</span>
              <select value={cruise.adults} onChange={(e) => setCruise({ ...cruise, adults: e.target.value })}>
                {[1, 2, 3, 4, 5, 6].map((n) => (
                  <option key={n} value={String(n)}>
                    {n} Adult{n > 1 ? 's' : ''}
                  </option>
                ))}
              </select>
            </label>
          </div>
          <button type="submit" className="mcr-search-submit" aria-label="Search cruises">
            <FaSearch size={20} />
          </button>
        </div>
        <p className="mcr-search-widget__note">
          Need help choosing?{' '}
          <a href={`tel:${CRUISE_PHONE_TEL}`}>Call our cruise team 24/7</a>
        </p>
      </form>
    </div>
  );
}
